<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon primary small">
      <div class="inner"><i class="ti ti-mail"></i></div>
    </div>
    <span class="title ms-2">Envoyer un email</span>
  </div>
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>
<div class="modal-content">
  <form [formGroup]="mailForm" class="d-flex flex-column gap-3 w-100">
    <div class="d-flex flex-column gap-2 form-group flex-grow-1">
      <label>Email *</label>
      <input type="text" formControlName="to">
    </div>
    <div class="d-flex flex-column gap-2 form-group flex-grow-1">
      <label>Objet *</label>
      <input type="text" formControlName="subject">
    </div>
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label>Message</label>
      <textarea formControlName="message"></textarea>
    </div>
    <!-- <div class="d-flex flex-column gap-2 form-group w-100" id="uploader">
      <label>Ajouter des fichiers</label>
      <app-file-uploader (onFilesAdded)="addFiles($event)"></app-file-uploader>
      <div class="list">
        <div class="content">
          <div class="item d-flex flex-row align-items-center justify-content-between" *ngFor="let f of files; let i = index;">
            <span class="name">{{ f.name }}</span>
            <div class="d-flex flex-row align-items-center">
              <button class="button m icon transparent" (click)="removeFile(i)"><i class="ti ti-trash"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="d-flex flex-row align-items-center justify-content-between gap-3 cartridge">
      <span class="label">
        M'ajouter en copie<br />
        <small>Vous recevrez également l'email envoyé au salarié</small>
      </span>
      <app-toggle formControlName="copy"></app-toggle>
    </div>
  </form>
</div>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Annuler</button>
  <button class="button m primary confirm" (click)="createInsured()" type="button">Confirmer<ion-spinner
      *ngIf="sendingMail" color="light" name="dots"></ion-spinner></button>
</div>